import { e as _extends } from './_rollupPluginBabelHelpers-e71b1aad.js';
import React__default, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { s as setDomAttributes } from './utilsHelpers-e4b21f4b.js';
import { n as nodeOrStringProp, d as domAttributesShape } from './PropTypes-e1e509ba.js';

function Button(props) {
  var primary = props.primary,
    secondary = props.secondary,
    transparent = props.transparent,
    type = props.type,
    children = props.children,
    content = props.content,
    className = props.className,
    onClick = props.onClick,
    disabled = props.disabled,
    fluid = props.fluid,
    qaData = props.qaData,
    loading = props.loading,
    domAttributes = props.domAttributes;
  var ref = useRef(null);
  useEffect(function () {
    setDomAttributes(ref, domAttributes);
  }, [domAttributes, ref]);
  var size = props.size;
  var allowedSizes = ['small', 'normal', 'large'];
  size = allowedSizes.some(function (validSize) {
    return validSize === size;
  }) ? "bf-button-size-".concat(size) : '';
  var addItem = function addItem(array, item) {
    var condition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    if (condition) {
      array.push(item);
    }
  };
  var buttonClasses = [];
  addItem(buttonClasses, 'bf-button');
  addItem(buttonClasses, 'bf-button-primary', primary);
  addItem(buttonClasses, 'bf-button-secondary', secondary);
  addItem(buttonClasses, 'bf-button-transparent', transparent);
  addItem(buttonClasses, 'bf-button-fluid', fluid);
  addItem(buttonClasses, 'bf-button-is-loading', loading);
  addItem(buttonClasses, size);
  addItem(buttonClasses, className);
  var buttonClassName = buttonClasses.join(' ');
  return /*#__PURE__*/React__default.createElement("button", _extends({
    // eslint-disable-line react/button-has-type
    className: buttonClassName,
    ref: ref,
    onClick: onClick,
    type: type,
    disabled: disabled
  }, qaData), /*#__PURE__*/React__default.createElement("span", {
    className: "bf-button-content"
  }, content || children), loading ? /*#__PURE__*/React__default.createElement("span", {
    className: "bf-button-loader"
  }) : null);
}
Button.defaultProps = {
  content: '',
  children: '',
  primary: false,
  secondary: false,
  transparent: false,
  disabled: false,
  className: '',
  onClick: null,
  type: 'button',
  size: 'normal',
  fluid: false,
  loading: false,
  qaData: {},
  domAttributes: []
};
Button.propTypes = {
  /**
  Button content
   */
  content: nodeOrStringProp,
  /**
  Button content
   */
  children: nodeOrStringProp,
  /**
  Button with max emphasis
   */
  primary: PropTypes.bool,
  /**
  Button with medium emphasis
   */
  secondary: PropTypes.bool,
  /**
  Button with lower emphasis
   */
  transparent: PropTypes.bool,
  /**
  Button with disabled state
   */
  disabled: PropTypes.bool,
  /**
  Button custom className
   */
  className: PropTypes.string,
  /**
  onClick function
   */
  onClick: PropTypes.func,
  /**
  Button html type
   */
  type: PropTypes.oneOf(['button', 'submit', 'reset']),
  /**
  Button size
   */
  size: PropTypes.string,
  /**
  Full width button
   */
  fluid: PropTypes.bool,
  /**
  Button with loading state
   */
  loading: PropTypes.bool,
  /**
  Give QA params
   */
  qaData: PropTypes.shape({}),
  /**
  Add the micro annotations to the tag HTML
   */
  domAttributes: PropTypes.arrayOf(PropTypes.shape(domAttributesShape))
};

export { Button as B };
//# sourceMappingURL=Button-a16585e5.js.map
